import fetch from 'isomorphic-fetch'
import * as types from '../../constants/ActionTypes'
import * as general from '../../constants/General'
import * as generalActions from '../../actions/generalActions'
import * as dataActions from '../../actions/dataActions'

export function receiveObjectGroupList(json) {
    return {
        type: types.RECEIVE_OBJECTGROUPLIST,
        json
    }
}

function fetchObjectGroupList(posid) {
    return dispatch => fetch(general.API_URL_OBJECTGROUPLIST + posid)
        .then(response => response.json())
        .then(json => dispatch(receiveObjectGroupList(json)));
}

export function getObjectGroupList(posid) {
    return dispatch => dispatch(fetchObjectGroupList(posid))
}

function setCurrentObjectGroupUnsafe(id) {
    return {
        type: types.SET_CURRENT_OBJECTGROUP,
        id
    }
}

export function setCurrentObjectGroup(id) {
    return (dispatch) => {
        dispatch(setCurrentObjectGroupUnsafe(id))
    }
}

function setSelectedObjectItemUnsafe(objectitem) {
    return {
        type: types.SET_SELECTED_OBJECTITEM,
        objectitem
    }
}

export function setSelectedObjectItem(objectitem) {
    return (dispatch) => {
        dispatch(setSelectedObjectItemUnsafe(objectitem));
    }
}

function setMessageBarTextUnsafe(messagebartext) {
    return {
        type: types.SET_MESSAGEBAR_TEXT,
        messagebartext
    }
}

export function setMessageBarText(messagebartext) {
    return (dispatch) => {
        dispatch(setMessageBarTextUnsafe(messagebartext));
    }
}

export function updateObjectItem(id, x, y) {
    return (dispatch, getState) => {
        const groups = [];
        getState().objectManagementState.objectgroups.map(objectGroup => {
            const editGroup = objectGroup;
            const objectItems = [];
            objectGroup.ObjectItems.map(objectItem => {
                const editObjectItem = objectItem;
                if (objectItem.ObjectItemId === id) {
                    editObjectItem.LocationX = x;
                    editObjectItem.LocationY = y;
                    editObjectItem.Show = false;
                }
                objectItems.push(editObjectItem);
                return '';
            })
            editGroup.ObjectItems = objectItems;
            groups.push(editGroup);

            return '';
        });

        dispatch(receiveObjectGroupList(groups));
    }
}

export function validNewLocation(id, x, y, width, height) {
    return function (dispatch, getState) {
        if (x < 0
            || y < 0) {
            return false;
        }

        const item = dispatch(dataActions.getObjectItemByXY(x, y, width, height));
        if (item !== null) {
            if (item.ObjectItemId !== id
                && item.ReceiptNumber > 0) {
                dispatch(generalActions.setMessageModal(true, 'Tafel al in gebruik!'));
                return false;
            }

            if (item.ObjectItemId !== id &&
                item.ReceiptNumber <= 0) {
                dispatch(generalActions.setConfirmModal('Tafel verplaatsen?', updateObjectItem, null, [id, x, y], null));
            }
        }
    }
}



// WEBPACK FOOTER //
// src/objectmanagement/actions/objectManagementActions.js